<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <SearchKeyWords></SearchKeyWords>
    <Classify
      class="classify"
      :class="{
        'classify-top': !$route.query.recommend && !$route.query.keywords,
      }"
      :items="classifyItems"
      @change="onClassifyChange"
    ></Classify>
    <ListSort v-model="sort"></ListSort>
    <List
      class="list"
      ref="list"
      url="/api/app/stateSchool/class/index"
      :search="params"
      :limit="15"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="classes-list clearfix">
          <template v-for="item in list">
            <ClassesItem :key="item.id" :item="item"></ClassesItem>
          </template>
        </div>
        <EmptyNew
          v-if="list.length == 0"
          class="classes-empty"
          title="暂无班级安排，敬请期待！"
        />
      </template>
    </List>
  </div>
</template>
<script>
import ListSort from "@/modules/stu/components/ListSort.vue";
import List from "@/components/List.vue";
import Classify from "../../components/Classify.vue";
import ClassesItem from "@/modules/stu/components/classes/ClassesItem.vue";
import EmptyNew from "@/components/EmptyNew.vue";
import SearchKeyWords from "@/modules/stu/components/SearchKeyWords.vue";

export default {
  name: "Classes",
  components: {
    ListSort,
    List,
    ClassesItem,
    Classify,
    EmptyNew,
    SearchKeyWords,
  },
  data() {
    return {
      sort: 0,
      recommend: this.$route.query.recommend,
      classifyItems: [],
      classify: 0,
      subClassify: 0,
      grade_id: 0,
    };
  },
  computed: {
    keywords() {
      return this.$route.query.keywords;
    },
    params() {
      let params = {
        course_classify_id: this.subClassify || this.classify,
        keywords: this.keywords,
        order_by: this.sort,
        grade_id: this.grade_id,
      };
      if (this.$route.query.nav) {
        params.nav_id = this.$route.query.nav;
      }
      if (this.$route.query.recommend) {
        params.recommend = this.$route.query.recommend;
      }
      return params;
    },
  },
  watch: {
    sort() {
      this.$refs.list.searchRefresh();
    },
    $route() {
      this.$refs.list.refresh();
    },
  },
  async created() {
    let data = await this.$http.get(
      "/api/app/systemSet/available/classifyAndGrad",
    );
    let classifyItems = [];
    if (data.config.switch_sch_attr_classify == 1) {
      classifyItems.push({
        id: "classify",
        name: "分类",
        value: { item: this.classify, child: this.subClassify },
        children: [{ id: 0, name: "全部" }, ...data.classifyData],
      });
    }
    if (data.config.switch_sch_attr_grade == 1) {
      classifyItems.push({
        id: "grade",
        name: "年级",
        value: { item: this.grade_id },
        children: [{ id: 0, name: "全部" }, ...data.gradeData],
      });
    }
    this.classifyItems = classifyItems;
  },
  methods: {
    onClassifyChange({ id, value }) {
      if (id == "classify") {
        this.classify = value.item;
        this.subClassify = value.child;
      } else if (id == "grade") {
        this.grade_id = value.item;
      }
      this.$refs.list.searchRefresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.classify {
  margin: 0;
}
.classify-top {
  margin-top: 24px;
}
.classes-list {
  margin-bottom: 4px;
}
.classes-empty {
  background-color: white;
  margin-bottom: 32px;
  border-radius: 5px;
  padding: 50px 0 32px 0;
  background-position: center 50px;
}
/deep/ {
  .pager {
    margin-bottom: 40px;
  }
}
</style>
